module.exports = __webpack_public_path__ + "img/homefire.ca0ae4bc.gif";